import { useEffect, useState } from "react";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebase"; // adjust path
import { ADMIN_EMAILS } from "../config/adminEmails"; // adjust path

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // 🔐 Redirect if already logged in
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        navigate("/dashboard");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleLogin = async () => {
    if (!ADMIN_EMAILS.includes(email)) {
      alert("Unauthorized email");
      return;
    }

    try {
      setLoading(true);

      await signInWithEmailAndPassword(auth, email, password);

      navigate("/dashboard"); // ✅ redirect after login
    } catch (error) {
      console.error(error);
      alert("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-slate-900 to-black">

      {/* background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-orange-500/20 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-blue-500/20 rounded-full blur-3xl" />
      </div>

      {/* glass card */}
      <div className="relative w-full max-w-md p-8 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl">

        {/* header */}
        <div className="mb-6 text-center">
          <img src="/logo-vertical.png" className="w-24 mx-auto mb-2" />
          <h1 className="text-3xl font-bold tracking-tight text-white">
            SkillAura Admin
          </h1>
        </div>

        {/* email */}
        <div className="mb-4">
          <label className="block text-sm text-slate-300 mb-1">
            Admin Email
          </label>
          <input
            type="email"
            placeholder="admin@skillaura.co.in"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-lg bg-black/40 text-white border border-white/20 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
        </div>

        {/* password */}
        <div className="mb-4">
          <label className="block text-sm text-slate-300 mb-1">
            Password
          </label>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-lg bg-black/40 text-white border border-white/20 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
        </div>

        {/* button */}
        <button
          onClick={handleLogin}
          disabled={loading}
          className="w-full py-3 rounded-lg font-medium bg-orange-500 hover:bg-orange-600 disabled:opacity-60 text-white transition-all"
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        {/* footer */}
        <p className="text-xs text-center mt-6 text-slate-400">
          Only authorized admins can access the system
        </p>
      </div>
    </div>
  );
}